module.exports = __webpack_public_path__ + "static/media/me-3.f92d2ad9.svg";